import { Redirect, useLocation } from 'react-router'
import { Link } from '../Link/Link'
import React from 'react'

export const paramsToCleanUp = ['resetToken', 'confirmToken']

export const getModeComponent =
  (Component) =>
  ({ mode, state, pathname, ...props }) => {
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('mode', mode)
    paramsToCleanUp.forEach((param) => searchParams.delete(param))
    return (
      <Component
        {...props}
        to={{ pathname, search: searchParams.toString(), state }}
      />
    )
  }

export const ModeRedirect = getModeComponent(Redirect)
export const ModeLink = getModeComponent(Link)
